<template>
  <div>
    <div class="text-center mb-5">
      <b-img
        class="p-5"
        width="800"
        :src="require('@/assets/icons/404.svg')"
      ></b-img>
      <div class="center-screen">
        <div class="page-title mb-4">Where did it go?</div>
        <div class="font-weight-bold mb-4">
          We couldn’t find what you were looking for.
          <br />You can go back to previous page.
        </div>
        <b-button
          v-if="hasPrevRoute"
          class="back-btn"
          variant="primary"
          @click="$router.go(-1)"
        >
          Back
        </b-button>
        <b-button
          v-else
          class="back-btn"
          variant="primary"
          @click="$router.replace('/home')"
        >
          Go to Home
        </b-button>
      </div>
      <b-img
        fluid
        width="1000"
        :src="require('@/assets/icons/no-results.svg')"
      ></b-img>
    </div>

    <footer-section />
  </div>
</template>

<script>
import FooterSection from '@/components/FooterSection'

export default {
  components: {
    FooterSection
  },

  computed: {
    hasPrevRoute() {
      return (
        !!this.$router.options.history &&
        this.$router.options.history.state.back
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.center-screen {
  min-height: auto;
  margin-top: -280px;
  margin-bottom: -80px;
}
.back-btn {
  width: 200px;
  z-index: 2;
}
</style>
